var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#f5fae5}.c{opacity:.4;fill:none;stroke:#4570b4;stroke-miterlimit:10}.d{opacity:.4;fill:#b0c75c}.e{opacity:.4;fill:none;stroke:#4570b4;stroke-miterlimit:10;stroke-width:1}.f{opacity:.4;fill:#4570b4}.g{opacity:.4;fill:#fff}.h{opacity:.4;fill:none;stroke:#fff;stroke-miterlimit:10}.i{fill:#90ae21}.j{fill:#c6606c}.k{fill:#00496a}.l{fill:#d9d9d9}.m{fill:#fac94a}.n{fill:#feb701}.o{fill:#05323b}.p{fill:#68a8de}.q{fill:#375c93}.r{fill:#ffde7e}.s{fill:#4570b4}.t{fill:#738186}.u{fill:#07404b}.v{fill:#c8dd7b}.w{fill:#ffa9b3}.x{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round}.y{fill:none;stroke:#aa4451;stroke-miterlimit:10}.z{fill:#bcdc49}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0 0h500v500h-500z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m430.7 276.1c-4.5 95.6-89.5 122.8-195.4 124.9-161.5 3.1-180.3-48.2-180.3-143.9 0-95.7 35.2-194.5 128.6-187.2 44.3 3.5 94.7 77 132.4 101.4 52 33.7 118 33 114.7 104.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m52.5 316.2c0 0 33.7-14.7 49.1-62.6 15.5-47.8 43.5-88.1 96.7-90.8 53.1-2.7 110.5 0.6 129.5-27.9 19-28.6-21.6-29.2-22.1 20.8-0.6 50.1 86.8 141.8 91.4 213.1 4.6 71.3-54.5 57.1-127.8 28.5-73.3-28.7-149.9 28-197.6 6.8-47.7-21.2-45.7-66.5-19.2-87.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m59.7 260.7c-10.7 0-19.3-8.6-19.3-19.3 0-10.7 8.6-19.3 19.3-19.3 10.6 0 19.3 8.6 19.3 19.3 0 10.7-8.7 19.3-19.3 19.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m77.1 258.8c-9.7 9.6-25.2 9.6-34.8 0-9.7-9.6-9.7-25.2 0-34.8 9.6-9.6 25.1-9.6 34.8 0 9.6 9.6 9.6 25.2 0 34.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m426 276.1c-12.4 0-22.5-10-22.5-22.5 0-12.4 10.1-22.5 22.5-22.5 12.5 0 22.5 10.1 22.5 22.5 0 12.5-10 22.5-22.5 22.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m268.9 192.9l-6.1 9.7h13z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m183.3 103.2l-8.2 12.8h17.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m244.1 129.2c-13 0-23.5-10.5-23.5-23.5 0-13 10.5-23.4 23.5-23.4 12.9 0 23.4 10.4 23.4 23.4 0 13-10.5 23.5-23.4 23.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m243.6 102.8l-1.3-2.5c-0.9-1.6-0.2-3.6 1.4-4.5 1.1-0.6 1.5-1.9 0.9-3l-1.9-3.8c-0.6-1.1-2-1.5-3.1-1l-1.7 0.9c-1.6 0.9-2.9 2.2-3.8 3.8l-0.5 1c-0.8 1.7-0.8 3.7 0 5.3l3.7 7.1 2.5 4.7 3.7 7.1c0.8 1.6 2.5 2.8 4.3 3l1.1 0.2c1.8 0.2 3.7-0.1 5.3-1l1.7-0.9c1.1-0.6 1.5-1.9 1-3l-2-3.8c-0.6-1.1-1.9-1.5-3-1-1.7 0.9-3.7 0.3-4.5-1.4l-1.3-2.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m415.7 370.3c0 2.7-2.2 4.9-4.9 4.9-2.7 0-4.8-2.2-4.8-4.9 0-2.6 2.1-4.8 4.8-4.8 2.7 0 4.9 2.2 4.9 4.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m125.3 113.4c-5 0-9-4-9-8.9 0-5 4-9 9-9 5 0 9 4 9 9 0 4.9-4 8.9-9 8.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m370.4 238.2c-4.9 0-9-4-9-9 0-4.9 4.1-8.9 9-8.9 5 0 9 4 9 8.9 0 5-4 9-9 9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m87.7 289.4c-4.8 0-8.7-3.9-8.7-8.8 0-4.8 3.9-8.7 8.7-8.7 4.9 0 8.8 3.9 8.8 8.7 0 4.9-3.9 8.8-8.8 8.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m426 269.1c-8.5 0-15.5-6.9-15.5-15.5 0-8.6 7-15.5 15.5-15.5 8.6 0 15.6 6.9 15.6 15.5 0 8.6-7 15.5-15.6 15.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m412.9 106.6h-107.6c-4.6 0-8.3 3.7-8.3 8.3v65c0 4.6 3.7 8.3 8.3 8.3h68.6v16.4c0 2.7 3.2 4.2 5.3 2.5l22.4-18.9h11.3c4.6 0 8.3-3.7 8.3-8.3v-65c0-4.6-3.7-8.3-8.3-8.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m440.1 114.7c0 9.7-2.8 18.8-7.6 26.4q-1.1 1.8-2.5 3.5c-8.7 11.6-22.5 19-37.9 19-8 0-15.5-2-22-5.4-15.5-8.1-26.1-24.6-26.1-43.5q0-3.3 0.4-6.5c3.2-23.9 23.3-42.4 47.7-42.4 26.5 0 48 21.9 48 48.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m430 144.6c-8.7 11.6-22.5 19-37.9 19-8 0-15.5-2-22-5.4 0.9-2.3 3.6-8.2 8.5-11.6 6.1-4.2 24.6-6.7 37.5-5.6 7.6 0.7 11.8 2.4 13.9 3.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m370.4 89.9l0.5 23.9c0 0 0.8 24.4 20.6 23.9 19.9-0.4 24.1-30.5 24.1-30.5l-3.2-18.3c0 0-23.2-15.5-42 1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m391.7 132c0 0 1.4 9.2-0.8 12.3-2.2 3 4.4 13.5 4.4 13.5l15.4-14.1c0 0-1-10.4-0.7-19.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m370.5 95.4c0 0 5.7 1.8 11.9 1.3 6.1-0.5 8.2-3 8.2-3 0 0 2 0.8 5.4 0.8 3.3 0 5.7-1.6 5.7-1.6 0 0-2.2 3.9-1.2 8.8 0.9 5 4.1 6.2 4.1 6.2 0 0 2.1-4.9 5.6-4.9 3.5 0 4.8 3.8 3.9 8.7-0.9 4.9-6.6 6.1-6.6 6.1l2.5 6.5c0 0 9.1-9.8 10.2-20.6 1-10.9-4.4-14.1-4.4-14.1 0 0 0.4-8-10.3-10.8-10.7-2.8-17.8-2.6-25.8 2 0 0-6.8-5.1-12.5-2-5.6 3.1-4 9.7-1.2 11.5 0 0-5.5 1.4-4.3 8.1 1.2 6.8 9 6.2 9 6.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m391.5 137.7c0 0 14.5-3.8 15.9-13.4 0 0 3.6 14-15.9 18.7 0 0 0.6-4.1 0-5.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m466.8 84c-2 12.3-13.5 20.6-25.8 18.6-12.2-2-20.5-13.6-18.5-25.8 2-12.3 13.5-20.6 25.8-18.6 12.2 2 20.5 13.6 18.5 25.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m441.1 87.5l-0.1-1.1c-0.2-2.2 0.5-4.5 2.5-6.9 1.8-2.2 2.8-3.7 2.8-5.6 0-2-1.3-3.4-3.8-3.4-1.4 0-3 0.5-4 1.2l-1-2.5c1.3-1 3.6-1.6 5.7-1.6 4.7 0 6.7 2.9 6.7 5.9 0 2.7-1.5 4.7-3.4 7-1.8 2.1-2.4 3.9-2.3 5.9v1.1c0 0-3.1 0-3.1 0zm-0.9 5.6c0-1.5 1-2.6 2.4-2.6 1.4 0 2.4 1.1 2.4 2.6 0 1.4-0.9 2.5-2.4 2.5-1.4 0-2.4-1.1-2.4-2.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m405.4 345.5q-0.1 0.3-0.2 0.6-2.9 4.1-6 8c-68.7 84.3-245.2 84.3-245.2 84.3v-100.6h251.2c0 0 0.9 5.4 0.2 7.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m405.4 345.5q-0.1 0.3-0.2 0.6-2.9 4.1-6 8l-245.2 27.9v-36.5c0 0 251.4 0 251.4 0z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m269.3 266.5l-12.2 12.9c0 0-2.4-2.5-5.4-6.5-1.4-1.8-3-4-4.4-6.4-1.8-3.1-3.5-6.5-4.4-9.9-3.2-11.5-1.9-35.6-1.9-35.6 0 0 5.1 0.5 6.9 2.5 10 11.1 21.4 43 21.4 43z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m223.6 308.6h-87l-7.9-66.9c-0.9-7.6 4.4-14.6 11.9-15.6l5.3-0.7 66.4-8.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m203.4 219c0 0-28.3 9.1-29.9 11.4-1.5 2.4 11.8 43.9 11.8 43.9l-2.6 34.3h57.7l2.9-32.8c0 0 6.2-6.7 6.5-17.9 0.4-11.2-7.8-36.9-7.8-36.9l-20.2-2.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m210.5 154.5c0 0-19.8-8.4-33.8 11.4-14 19.8 0.5 50.9 0.5 50.9 0 0 35.8-4.7 45.7-5.6 9.9-1 11.9-1 11.9-1 0 0 5.1-31.3-5.8-42.8-10.9-11.5-18.5-12.9-18.5-12.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m217.8 231.8l-16.6-11.5c0 0 1.3-4.3 1-8.7-0.1-1-0.2-1.9-0.5-2.9q-0.2-0.6-0.5-1.3l16.6-0.8c0 0 0.1 1.3 0.4 3.1 0.3 1.3 0.7 2.9 1.2 4.3 0.4 1 0.9 1.9 1.5 2.6 2.6 2.6-3.1 15.2-3.1 15.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m219.4 214c-2.1 0.1-11.3 0.2-17.2-2.4-0.1-1-0.2-1.9-0.5-2.9 0 0 11.2 1.4 16.5 1 0.3 1.3 0.7 2.9 1.2 4.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m227.2 162.1l2.8 22.9c0 0 3.6 23.7-15.5 26-19.1 2.3-25.5-19.8-25.5-19.8l-2.2-24.4c0 0 20.1-18 40.4-4.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m218.5 163.8c0 0-2.5 6.2-10.7 10.5-7.3 3.9-14.1 5-14.1 5 0 0-1.1 6.4-4.8 10.5 0 0-6.4-12.1-3.8-22.5 2.6-10.4 16.1-15.5 27.9-14.4 11.8 1 16 5.4 17.6 12.3 1.5 6.8-1.1 16.1-1.1 16.1 0 0-2.5-15.3-11-17.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m186.8 184.7c0 0-2.3-17.4 11.2-26.7 8.7-6 19.8-4.4 19.8-4.4 0 0-7-5.3-20.7 0.8-13.7 6-14.4 19.7-13 30.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m156.5 308.6h-19.9l-7.9-66.9c-0.9-7.6 4.4-14.6 11.9-15.6l5.3-0.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m205.4 206.8c-9.1 0-15.9-6.4-16.2-6.7l1.2-1.3c0.1 0.1 7.5 7 16.7 6.1l0.2 1.8q-1 0.1-1.9 0.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m431.1 346.1h-273c-7.3 0-14.2-3-19.1-8.3l-15-16.3c-5.8-6.3-1.2-16.3 7.6-16.3h266.4c9.2 0 18.1 3.5 24.7 9.7l15.4 14.3c6.6 6.2 2.1 16.9-7 16.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m306.6 224.8c-0.5 0.3-1.3 0.8-2.1 1.3l-0.2-0.3c2.5-1.6 6.2-4.1 6-4.7-0.4-0.9-2.3-0.4-3.7 0.3-0.8 0.5-2.2 1.3-3.6 2.2l-0.1-0.2c2.4-1.5 6.6-4.3 6.3-4.9-0.4-0.9-2.2-0.4-3.6 0.3-0.9 0.5-2.6 1.5-4.1 2.4l-0.1-0.2c2.4-1.6 5.6-3.8 5.4-4.3-0.4-0.9-2.3-0.5-3.6 0.3-1.9 1-7.4 4.4-7.4 4.4l-4 1.4c0.9-1.4 3.3-6.5 2.2-6.5-1.1 0-4.2 3.6-5.5 7.3-1 2.7-1.1 5.2-1.1 6.3l-34.8 44.2c0 0 0.8 1.3 2 3 3.7 5 12.1 6.1 16.9 2.3 3.9-3 6.9-6.9 9.9-11 5.5-7.6 13.9-27.8 15.8-32.7l7.9-7.4c2.2-1.4 4.9-3.3 4.7-3.7-0.3-0.9-2-0.4-3.2 0.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m215 316c0 0 4.1 3 5.7 7.1 1.6 4-8.7 6.7-25.8 0.8-12.5-4.2 8.6-17.2 20.1-7.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m208.6 207.9h-2.3c-0.9 0-1.5-0.7-1.5-1.5v-1.5c0-0.8 0.6-1.5 1.5-1.5h2.3c0.8 0 1.4 0.7 1.4 1.5v0.7 0.8c0 0.8-0.6 1.5-1.4 1.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m196.6 189.9c1.3 6.4-2 12.4-7.4 13.5-5.4 1.2-10.7-3.1-12-9.5-1.3-6.3 2-12.4 7.4-13.5 5.3-1.1 10.7 3.1 12 9.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m191.2 191c0.7 3.8-1.2 7.4-4.4 8-3.1 0.7-6.3-1.8-7-5.6-0.8-3.8 1.2-7.3 4.3-8 3.2-0.6 6.3 1.9 7.1 5.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m177.2 227.9c0 0-4.9 0.8-6.8 3.9-8.5 13.5-25 54.6-25 54.6l15.9 7.1c0 0 20.9-24.2 22.8-35.7 1.9-11.6-6.9-29.9-6.9-29.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m159.8 289.9l32.6 21.3-4.6 10.2c0 0-29.3-10.6-38.3-17.4-9-6.8-4.1-17.6-4.1-17.6 0 0 5-0.5 14.4 3.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m191.5 310.8c0 0 10.9-0.5 14.9-0.5 4 0 10.9 6.5 10.1 8.6-0.8 2.1-8.7-4.3-8.7-4.3l-0.4 0.8c0 0 7 4.3 7.4 6 0.4 1.6-1.2 1.3-3.5 0.4-2.3-1-5.8-3.2-5.8-3.2l-0.4 0.4c0 0 6.7 4.1 6.7 5.6 0 1.5-4.8-0.2-8.3-2.5l-0.5 0.7c0 0 4.4 2.2 4.7 3.6 0.3 1.5-2.1 0.9-4.7-0.4-2.6-1.2-5-1.3-8.4-1.8-3.4-0.6-7.4-3.1-7.4-3.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m393.5 251.4l-15.6 78.4h-115.8l15.5-78c0.4-1.6 1.8-2.8 3.4-2.8h110.6c1.2 0 2.2 1.1 1.9 2.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m262.1 329.8l-31.8-10.4c-1.1-0.4-1.9-1.4-1.9-2.6 0-1.5 1.2-2.7 2.7-2.7h34.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m178.6 231.1c0 0 7.1 20.2 2.8 34 0 0 14.6-16.2-2.8-34z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m251.7 272.9c-1.4-1.8-3-4-4.4-6.4 3-11.6-3.9-37.3-3.9-37.3 15 19.1 10.8 36.9 8.3 43.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m284.6 253.6l93.3 76.2h-106.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m340.7 302.1c-4.8 2-10.2-0.3-12.2-5-1.9-4.8 0.3-10.2 5.1-12.2 4.8-1.9 10.2 0.3 12.1 5.1 2 4.8-0.3 10.2-5 12.1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m202.1 215.8l15.7 16c0 0-2.7 3.8-7.2 3.7-4.6-0.1-7.1-5.9-8.4-8.9-1.3-3-3.9-6.3-3.9-6.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m217.8 231.8c0 0 4.1 2.4 8 0.7 4-1.7 2.9-4.3 1.5-7.1-1.3-2.7-2.8-7.7-2.8-7.7l-4.6-2.6c0 0 0.8 10.6-2.1 16.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m242.1 262.7l-39.7 3.8c0 0 8.9 6.4 22.6 4.5 13.7-1.9 17.1-8.3 17.1-8.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m153.4 133.7h-71.7c-4.5 0-8.3 3.7-8.3 8.3v19c0 4.6 3.8 8.3 8.3 8.3h60.4l19.6 11.3v-11.3-5.5-21.8c0-4.6-3.7-8.3-8.3-8.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m79 142.3h74.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m79 151.5h74.7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m79 160.6h74.7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m157.6 354.8c1.8-15.5-10.4-13.2-18.8-5-8.4 8.2-16.6 3.6-7.3-11.7 9.3-15.3 16.1-20 14.8-27.7-1.3-7.7-8-4.3-19.6 2.1-11.6 6.4-0.6-10.3-1.5-26.2-0.9-15.9-16.7-7.9-18 5.4-1.3 13.4 4.7 28.3-3 25.4-7.6-3-12.2-20.7-19.2-12.4-7 8.4 19.6 36.8 18.7 45.4-0.9 8.5-20-17.6-25.5-9-5.5 8.6 18.3 66 38.9 64.4 26.1-2 38.6-35.2 40.5-50.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m115.2 293.6c0 0-3.3 17.9-2 40.7 1.4 22.8 4.3 80.1 4.3 80.1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m92.9 316.2c0 0 15.1 17.9 20.5 21.8 0 0 19.5-18.8 23.3-21.8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m84 352c0 0 22.7 22.9 31.5 24.4l33.4-22.4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m108.1 396.7c0 0 9.9-21.8 4.6-33.4-5.3-11.7-12.9-4.9-15.3 4.4-2.4 9.4-10.1 9.7-10.1-5 0-14.7 2.8-20.9-1.4-25.8-4.2-4.8-7.5 0.4-12.9 9.8-5.4 9.5-4.9-6.9-12.2-17.7-7.4-10.7-15.1 1.5-10.3 11.5 4.7 9.9 15.3 17.8 8.7 19-6.7 1.2-17.5-9.3-18.8-0.4-1.3 8.8 29.5 17.4 32.5 23.8 3 6.4-21.5-3.8-21.7 4.6-0.2 8.4 28.4 23.1 41.3 20.9 12.9-2.2 15.6-11.7 15.6-11.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m56.3 335.5c0 0 37.4 60.2 45.3 78.9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m50.2 364.1l26.3 4.7 5.4-22.7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m64.1 391.1l28.1 4.9 11.6-25.5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m91.4 414.4h47.6l-4.1 24h-38.5z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m139.6 421h-48.3c-1.8 0-3.2-1.4-3.2-3.2v-2.5c0-1.8 1.4-3.2 3.2-3.2h48.3c1.8 0 3.2 1.4 3.2 3.2v2.5c0 1.8-1.4 3.2-3.2 3.2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m311.6 441.1c-18.2 0-33-14.8-33-33.1 0-18.3 14.8-33 33-33 18.3 0 33.1 14.7 33.1 33 0 18.3-14.8 33.1-33.1 33.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m334.4 397.9v22.9c0 1.1-0.9 2-2 2h-41.5c-1.2 0-2.1-0.9-2.1-2v-22.9c0-1.2 0.9-2.1 2.1-2.1h41.5c1.1 0 2 0.9 2 2.1zm-1.1-0.2c-0.3-0.4-0.9-0.6-1.4-0.3l-19 12.5-22.2-12.5c-0.4-0.3-1.1-0.1-1.3 0.4-0.3 0.5-0.1 1.1 0.4 1.3l22.7 12.8q0.2 0.1 0.5 0.1 0.2 0 0.5-0.1l19.5-12.8c0.5-0.3 0.6-0.9 0.3-1.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m337.1 404.5c-6.7 0-12.2-5.5-12.2-12.3 0-6.8 5.5-12.2 12.2-12.2 6.8 0 12.3 5.4 12.3 12.2 0 6.8-5.5 12.3-12.3 12.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.428b4b694e58b520653376c3df75ad4e.svg";
export { ForwardRef as ReactComponent };